<template>
  <div>
    <v-card class="mb-3">
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" sm="6" md="2" v-if="role === 'SUPERADMIN'">
            <v-select
              outlined dense hide-details
              :items="offices"
              item-text="name"
              item-value="id"
              label="Sede"
              clearable
              v-model="filterOffice"
            ></v-select>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-text-field
              v-model="filterFrom"
              label="Desde"
              type="date"
              outlined dense hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="6" sm="3" md="2">
            <v-text-field
              v-model="filterTo"
              label="Hasta"
              type="date"
              outlined dense hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="auto">
            <v-btn color="secondary" @click="loadRegisters">Buscar</v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <v-btn color="success" @click="dialogOpen = true" :disabled="hasOpenRegister">
              <v-icon left>mdi-cash-register</v-icon> Abrir Caja
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="registers"
        hide-default-footer
        :loading="$store.state.cashRegister.isLoading"
        no-data-text="No hay cierres de caja"
        :items-per-page="20"
      >
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="item.status === 'OPEN' ? 'warning' : 'success'" text-color="white" small>
            {{ item.status === 'OPEN' ? 'Abierta' : 'Cerrada' }}
          </v-chip>
        </template>
        <template v-slot:[`item.opening_balance`]="{ item }">{{ item.opening_balance | currency }}</template>
        <template v-slot:[`item.total_income`]="{ item }">
          <span v-if="item.incomes_sum_amount != null">{{ item.incomes_sum_amount | currency }}</span>
          <span v-else>—</span>
        </template>
        <template v-slot:[`item.actual_cash`]="{ item }">{{ item.actual_cash != null ? (item.actual_cash | currency) : '—' }}</template>
        <template v-slot:[`item.cash_income`]="{ item }">{{ item.cash_income != null ? (item.cash_income | currency) : '—' }}</template>
        <template v-slot:[`item.electronic_income`]="{ item }">{{ item.electronic_income != null ? (item.electronic_income | currency) : '—' }}</template>
        <template v-slot:[`item.total_expenses`]="{ item }">
          <span v-if="item.expenses_sum_amount != null">{{ item.expenses_sum_amount | currency }}</span>
          <span v-else>0</span>
        </template>
        <template v-slot:[`item.total_tips`]="{ item }">
          <span v-if="item.tips_sum_amount != null">{{ item.tips_sum_amount | currency }}</span>
          <span v-else>0</span>
        </template>
        <template v-slot:[`item.expected_balance`]="{ item }">{{ item.expected_balance != null ? (item.expected_balance | currency) : '—' }}</template>
        <template v-slot:[`item.opened_at`]="{ item }">{{ item.opened_at | shortDate }}</template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :color="item.status === 'OPEN' ? 'warning' : 'primary'"
                v-bind="attrs" v-on="on"
                class="px-1"
                @click="manage(item)"
              >
                {{ item.status === 'OPEN' ? 'mdi-cog-outline' : 'mdi-eye-outline' }}
              </v-icon>
            </template>
            <span>{{ item.status === 'OPEN' ? 'Gestionar' : 'Ver detalle' }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-pagination v-model="page" :length="totalPages" :total-visible="8" circle class="mt-2" @input="loadRegisters"></v-pagination>
    </v-card>

    <v-dialog v-model="dialogOpen" width="420" persistent>
      <v-card>
        <v-card-title>Abrir Caja</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-form ref="formOpen" v-model="validOpen" lazy-validation>
            <v-text-field
              v-model="openingBalance"
              :rules="[r.required, r.positive]"
              label="Valor de apertura"
              type="number"
              outlined dense
              prefix="$"
            ></v-text-field>
            <v-text-field
              v-model="openedAt"
              label="Fecha y hora de apertura"
              type="datetime-local"
              outlined dense
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogOpen = false">Cancelar</v-btn>
          <v-btn text color="success" :disabled="!validOpen" :loading="$store.state.cashRegister.isLoading" @click="doOpen">Abrir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { SET_OFFICES } from "@/store/offices";
export default {
  name: "CashRegisters",
  filters: {
    currency(v) { return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" }).format(v); },
    shortDate(v) { return v ? v.substring(0, 16).replace("T", " ") : ""; },
  },
  data: () => ({
    registers: [],
    offices: [],
    filterOffice: null,
    filterFrom: "",
    filterTo: "",
    page: 1,
    totalPages: 1,
    dialogOpen: false,
    validOpen: true,
    openingBalance: "",
    openedAt: "",
    hasOpenRegister: false,
    r: {
      required: (v) => (v !== "" && v != null) || "Campo requerido",
      positive: (v) => parseFloat(v) >= 0 || "No puede ser negativo",
    },
    headers: [
      { text: "Fecha apertura", value: "opened_at" },
      { text: "Estado", value: "status" },
      { text: "Apertura", value: "opening_balance" },
      { text: "Total ingresos", value: "total_income", sortable: false },
      { text: "Efectivo", value: "cash_income", sortable: false },
      { text: "Electrónico", value: "electronic_income", sortable: false },
      { text: "Gastos", value: "total_expenses", sortable: false },
      { text: "Propinas", value: "total_tips", sortable: false },
      { text: "Cajero", value: "user.name", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
  }),
  computed: {
    role() { return this.$store.state.user.user?.role; },
  },
  created() {
    this.$store.dispatch("getCurrentCashRegister").then((r) => {
      this.hasOpenRegister = r && r.status === "OPEN";
    });
    this.loadRegisters();
    if (this.role === "SUPERADMIN") {
      this.$store.dispatch("getOfficesAll");
      this.$store.subscribe((m, s) => {
        if (m.type === SET_OFFICES) this.offices = s.offices.offices;
      });
    }
  },
  methods: {
    loadRegisters() {
      let q = "page=" + this.page;
      if (this.filterOffice) q += "&office=" + this.filterOffice;
      if (this.filterFrom) q += "&from=" + this.filterFrom;
      if (this.filterTo) q += "&to=" + this.filterTo;
      this.$store.dispatch("getCashRegisters", q + "&").then(() => {
        const data = this.$store.state.cashRegister.registers;
        this.registers = data.data || data;
        this.totalPages = data.last_page || 1;
      });
    },
    doOpen() {
      if (!this.$refs.formOpen.validate()) return;
      const form = { opening_balance: this.openingBalance };
      this.openedAt = this.openedAt || this.localNow();
      form.opened_at = this.openedAt;
      this.$store.dispatch("openCashRegister", form).then(() => {
        this.dialogOpen = false;
        this.hasOpenRegister = true;
        this.loadRegisters();
      });
    },
    localNow() {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()) +
        "T" + pad(d.getHours()) + ":" + pad(d.getMinutes());
    },
    manage(item) {
      this.$router.push({ name: "ManageCashRegister", params: { id: item.id } });
    },
  },
};
</script>
